import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import EditorField from '../EditorField'
import Icon24 from '../Icon'
import Spinner from '../Spinner'

export const StyledEditorField = styled(EditorField)`
  position: relative;
`

export const SpinnerContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledSpinner = styled(Spinner)`
  width: 14px;
  height: 14px;
`

export const SuccessIcon = styled(Icon24.Success)`
  color: ${Colors.Green50};
`

export const ReceiveAdsContainer = styled.div`
  padding-top: 8px;
  color: ${Colors.Neutral50};
`
